import "./Skills.css";
import { SECTIONS, SKILLS } from "../../data";

export default function Skills() {
  const renderSkillCard = (skill) => {
    return (
      <div className="skill-card-container">
        <h2>{skill.title}</h2>
        <div className="skill-card">
          {skill.items.map((item, index) => (
            <div key={index} className="skill-card-item">
              {item.icon ? item.icon : ""}
              <p>{item.name}</p>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="skills-container" id={SECTIONS.SKILLS}>
      <h1 className="skills-title">Skills</h1>
      {SKILLS.map(renderSkillCard)}
    </div>
  );
}
